import TableFooter from "@mui/material/TableFooter";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { DataTablePagination } from "./DataTablePagination";

import { useStyles } from "../DataTable.styles";
import { useDataPagination } from "../DataTableContext";

// TODO voir pour l'optimisation et éviter les rerender ici
export const TFooter = () => {
  const classes = useStyles();
  const {
    pagination: { rowsPerPage, total },
  } = useDataPagination();

  return (
    <>
      {rowsPerPage < total && (
        <TableFooter className={classes.tableFooter}>
          <TableRow>
            <TableCell colSpan={100} className={classes.tableCell}>
              <DataTablePagination />
            </TableCell>
          </TableRow>
        </TableFooter>
      )}
    </>
  );
};
